export type FaciliooKeyTableRow = {
  definition: string;
  mapping: string;
  briefanrede_1?: string;
  briefanrede_2?: string;
};

export const DEFAULT_FACILIOO_ANREDE_KEY_TABLE: FaciliooKeyTableRow[] = [
  { definition: "Frau", mapping: "frau, fr, fr.", briefanrede_1: "Sehr geehrte Frau", briefanrede_2: "" },
  { definition: "Herrn", mapping: "herr, herrn, hr, hr.", briefanrede_1: "Sehr geehrter Herr", briefanrede_2: "" },
  { definition: "Frau / Frau", mapping: "frau/frau, frau und frau", briefanrede_1: "Sehr geehrte Frau", briefanrede_2: "Sehr geehrte Frau" },
  { definition: "Frau / Herrn", mapping: "frau/herr, frau/herrn, frau und herr, herr und frau", briefanrede_1: "Sehr geehrte Frau", briefanrede_2: "Sehr geehrter Herr" },
  { definition: "Herrn / Herrn", mapping: "herr/herr, herrn/herrn, herr und herr, herrn und herrn", briefanrede_1: "Sehr geehrter Herr", briefanrede_2: "Sehr geehrter Herr" },
  { definition: "Eheleute", mapping: "eheleute", briefanrede_1: "Sehr geehrte Frau", briefanrede_2: "Sehr geehrter Herr" },
  { definition: "Erbengemeinschaft", mapping: "erbengemeinschaft", briefanrede_1: "Sehr geehrte Damen und Herren", briefanrede_2: "" },
  { definition: "Eigentümergemeinschaft", mapping: "eigentuemergemeinschaft, eigentümergemeinschaft", briefanrede_1: "Sehr geehrte Damen und Herren", briefanrede_2: "" },
  { definition: "Firma", mapping: "firma, gmbh, ag, kg, ug", briefanrede_1: "Sehr geehrte Damen und Herren", briefanrede_2: "" }
];

export const DEFAULT_FACILIOO_TITEL_KEY_TABLE: FaciliooKeyTableRow[] = [
  { definition: "Dr.", mapping: "dr, dr." },
  { definition: "Prof.", mapping: "prof, prof." },
  { definition: "Prof. Dr.", mapping: "prof dr, prof. dr., prof. dr" },
  { definition: "Dipl.-Ing.", mapping: "dipl ing, dipl.-ing., dipl.-ing" },
  { definition: "Dipl.-Kfm.", mapping: "dipl kfm, dipl.-kfm., dipl.-kfm" }
];

type SettingsLike = {
  faciliooAnredeKeyTable?: Array<{ definition?: string; mapping?: string }>;
  faciliooTitelKeyTable?: Array<{ definition?: string; mapping?: string }>;
} | null | undefined;

export const getAnredeDefinitionsFromSettings = (management: SettingsLike): string[] => {
  const rows = Array.isArray(management?.faciliooAnredeKeyTable)
    ? management!.faciliooAnredeKeyTable
    : DEFAULT_FACILIOO_ANREDE_KEY_TABLE;

  const options = rows
    .map((row) => String(row?.definition ?? "").trim())
    .filter(Boolean);

  return Array.from(new Set(options.length ? options : DEFAULT_FACILIOO_ANREDE_KEY_TABLE.map((row) => row.definition)));
};

export const getTitelDefinitionsFromSettings = (management: SettingsLike): string[] => {
  const rows = Array.isArray(management?.faciliooTitelKeyTable)
    ? management!.faciliooTitelKeyTable
    : DEFAULT_FACILIOO_TITEL_KEY_TABLE;

  const options = rows
    .map((row) => String(row?.definition ?? "").trim())
    .filter(Boolean);

  return Array.from(new Set(options.length ? options : DEFAULT_FACILIOO_TITEL_KEY_TABLE.map((row) => row.definition)));
};
